/*
 * @Description: 保养建议
 * @Author: webJ
 */

import { mapState, mapActions } from 'vuex'
import viewName from '../constant.js'
import { wxShare } from '@/utils/wxsdk'
// import { toQueryObject } from '@/utils/util'
import { getAdviceGoodsData } from '@/models/advice.js'
import { setLocalConfig } from '@/utils/session'

import searchBox from './components/searchBox.vue'
import adviceProject from './components/adviceProject.vue'
import Footer from '@/components/footer/footer.vue'
import buyInfo from './components/buyInfo.vue'
import selectGoods from './components/selectGoods.vue'
import Sku from '@/components/sku/sku.tpl.vue'

export default {
    name: viewName.advice,
    inject: ['showLoading', 'hideLoading'],
    components: {
        Sku,
        searchBox,
        adviceProject,
        buyInfo,
        selectGoods,
        'fc-footer': Footer,
    },
    data () {
        return {
            sstore_id: '', // 门店id
            selectList: [], // 已选列表
            skus: {}, // 切换规格使用：规格参数
        }
    },
    computed: {
        ...mapState({
            drive_mileage: ({ advice }) => advice.drive_mileage, // 汽车公里数
            forecast_drive_mileage: ({ advice }) => advice.forecast_drive_mileage, // 预计保养公里数
            model_name: ({ advice }) => advice.model_name, // 汽车简称
            maintain_id: ({ advice }) => advice.maintain_id, // 保养id
            sstore_name: ({ advice }) => advice.sstore_name, // 门店名称
            vehicle_id: ({ advice }) => advice.vehicle_id, // 机型id
            list: ({ advice }) => advice.list, // 保养项目列表
            selectData: ({ advice }) => advice.selectData, // 已选数据
            nowSelectGoods: ({ advice }) => advice.nowSelectGoods, // 当前选择的商品
            isWeixin: ({ appInfo }) => appInfo.isWeixin // 是否是微信环境
        })
    },
    watch:{
        /**
         * 筛选出已选列表
         */
        selectData (nVal) {
            let record = { services: new Map(), goods: new Map() }

            // 合并商品
            for (let i = 0; i < nVal.goodsList.length; i++) {
                let good = nVal.goodsList[i]
                let predata = record['goods'].get(good.id)
                if (predata) {
                    let newObj = { ...predata }
                    newObj['selected_num'] += good['selected_num']
                    record['goods'].set(good.id, newObj)
                } else {
                    record['goods'].set(good.id, good)
                }
            }

            // 合并服务
            for (let i = 0; i < nVal.servicesList.length; i++) {
                let service = nVal.servicesList[i]
                let predata = record['services'].get(service.service_id)
                if (predata) {
                    let newObj = { ...predata }
                    newObj['selected_num'] += service['selected_num']
                    record['services'].set(service.service_id, newObj)
                } else {
                    record['services'].set(service.service_id, service)
                }
            }

            /* 统一成 同一种数据格式 */
            const newList = {
                goods: [...record.goods.values()],
                services: [...record.services.values()],
            }
            /* 商品 */
            const goodsArr = newList.goods.map((item) => {
                return {
                    id: item.id,
                    price: item.discount,
                    number: item.selected_num,
                    name: item.sku_name
                }
            })
            /* 服务 */
            const servicesArr = newList.services.map((item) => {
                return {
                    id: item.service_id,
                    price: item.service_price,
                    number: item.selected_num,
                    name: item.service_name
                }
            })
            const selectList = goodsArr.concat(servicesArr)
            this.selectList = selectList
        }
    },
    created () {
        // 调取，用于通过code获取用户信息并且保存到本地并且进行绑定手机号码的逻辑
        // this.getWxUserInfo(this.$route.query.code || '').then(_ => {
        //     const _thisPath = this.$route.path
        //     let _thisQuery = this.$route.query
        //     _thisQuery['code'] && delete _thisQuery['code'] && this.$router.replace(`${_thisPath}?${toQueryObject(_thisQuery)}`)
        // })
    },
    /* keep-alive 触发 */
    activated () {
        console.log('activated')
        this.$emit('setHeader', {
            title: '保养建议',
            showHeader: true,
            showLeft: false,
        })
        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
    },
    async mounted () {
        /* 微信分享 */
        this.configWxShare()

        /* 获取参数 */
        const { sstore_id, maintain_id } = this.$route.query
        this.sstore_id = sstore_id

        /* 显示loading */
        this.showLoading()
        /* 获取数据 */
        await this.getAdviceData({
            sstore_id,
            maintain_id
        })
        /* 隐藏loading */
        this.hideLoading()
    },
    methods: {
        ...mapActions([
            'getAdviceData',
            'setAppClass',
            'getWxUserInfo',
            'verifyUserInfo',
            'updateAdviceList'
        ]),
        /**
         * 配置微信分享
         */
        configWxShare () {
            /* 设置当前地址到缓存，给其他页面做微信分享用 与个人中心返回用 */
            sessionStorage.setItem('ADVICE_HREF', location.href)
            if (this.isWeixin) {
                wxShare({
                    link: location.href,
                    title: '为您推荐了一份爱车保养方案',
                    imgUrl: 'https://image.carisok.com/images/mall.png',
                    desc: '海量优质车品，智能匹配车型，车辆保养更轻松'
                })
            }
        },
        /**
         * 打开规格切换弹窗
         */
        onShowSkuPopup (data) {
            this.skus = {
                ...data
            }
            this.$refs.sku.open()
        },
        /**
         * 立即购买
         */
        async onBuy () {
            /* 验证登录 */
            await this.verifyUserInfo()
            /* 兼容创建订单的数据格式 */
            const goods = this.selectData.goodsList.map((item) => {
                const obj = {
                    goods_id: item.id,
                    price: item.discount,
                    quantity: item.selected_num,
                    baseItemCode: item.baseItemCode,
                    goods_type: item.goods_type,
                }
                return obj
            })

            const services = this.selectData.servicesList.map((item) => {
                const obj = {
                    service_id: item.service_id,
                    price: item.service_price,
                    quantity: item.selected_num,
                    baseItemCode: item.baseItemCode,
                }
                return obj
            })

            /* 设置sessionStorage数据 给确认订单使用 */
            setLocalConfig('CONFIRM_ORDER', {
                marketing_id: '',
                sstore_id: this.sstore_id, // 门店id
                goods: goods,
                services: services
            })
            /* 跳转确认订单 */
            this.$router.push({
                path: '/confirmOrder',
                query: {
                    source: 'advice', // 表示从保养建议进来
                    maintain_id: this.maintain_id
                }
            })
        },
        /**
         * 显示选择的商品弹窗
         */
        async onShowSelectDialog () {
            /* 验证登录 */
            await this.verifyUserInfo()
            this.$refs.selectGoodsPopup.show()
        },
        /**
         * 清空所选商品
         */
        onClearAllSelect () {
            const list = JSON.parse(JSON.stringify(this.list))
            const newList = list.map((item) => {
                const goodsArr = item.goods.map((childrenItem) => {
                    childrenItem.is_selectd = 0
                    return childrenItem
                })
                const servicesArr = item.services.map((childrenItem) => {
                    childrenItem.is_selectd = 0
                    return childrenItem
                })
                item.is_selectd = 0
                item.goods = goodsArr
                item.services = servicesArr
                return item
            })
            this.updateAdviceList(newList)
            // data.list = newList
        },
        /**
         * 子组件回调
         * 商品切换规格
         */
        async onChangeSku (obj) {
            const list = JSON.parse(JSON.stringify(this.list))
            /* 请求数据：通过规格id查询 兼容保养建议列表的数据 */
            const data = await getAdviceGoodsData({
                sstore_id: this.sstore_id,
                goods_type: obj.selectedSkuComb.goods_type,
                goods_id: obj.selectedSkuComb.goods_id, // 商品规格id
                spu_id: obj.selectedSkuComb.spu_id, // 商品id
                vehicle_id: this.vehicle_id // 车型id
            })
            /* 读sessionStorage存储的当前点击的数组索引 */
            const adviceParentIndex = Number(sessionStorage.getItem('adviceParentIndex'))
            const adviceChildrenIndex = Number(sessionStorage.getItem('adviceChildrenIndex'))
            /* 原始Item */
            const originItem = list[adviceParentIndex]['goods'][adviceChildrenIndex]
            /* 覆盖数据：是否选中 && 已选数量 */
            const freezeData = {
                is_selectd: originItem.is_selectd,
                selected_num: obj.selectedNum,
            }
            list[adviceParentIndex]['goods'][adviceChildrenIndex] = Object.assign(data, freezeData)
            this.updateAdviceList(list)
            this.$refs.sku.close()
        }
    },
}
